import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const items = [{
  name: 'Complete manual "The Silent Fire" (55 pages)',
  value: '$7'
}, {
  name: 'Master shopping list with real costs',
  value: '$9'
}, {
  name: 'Golden Paste preparation guide',
  value: '$9'
}, {
  name: 'The 4 morning movements illustrated guide',
  value: '$9'
}, {
  name: 'Immediate access by digital download',
  value: 'Free'
}];
export function WhatYouGet() {
  return <section className="bg-forest-green py-12 md:py-16 px-4 sm:px-6 lg:px-8 text-white" data-id="element-270">
      <div className="max-w-3xl mx-auto" data-id="element-271">
        <FadeIn data-id="element-272">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gold mb-12" data-id="element-273">
            Everything You Receive Today:
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-274">
          <div className="bg-white/5 rounded-2xl p-6 md:p-8 border border-white/10" data-id="element-275">
            <div className="space-y-6" data-id="element-276">
              {items.map((item, index) => <div key={index} className="flex items-center justify-between border-b border-white/10 pb-4 last:border-0 last:pb-0" data-id="element-277">
                  <div className="flex items-center gap-4 pr-4" data-id="element-278">
                    <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0" data-id="element-279" />
                    <span className="text-lg font-medium" data-id="element-280">{item.name}</span>
                  </div>
                  <span className="text-lg font-bold text-sage-light whitespace-nowrap" data-id="element-281">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="mt-8 pt-6 border-t-2 border-gold/30 flex items-center justify-between" data-id="element-282">
              <span className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-283">
                Total Value
              </span>
              <span className="text-3xl md:text-4xl font-bold text-gold line-through opacity-80" data-id="element-284">
                $34
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}